import { Route, Routes } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Main from "./components/dashboard/main";
import NewProject from "./components/dashboard/newProject";
import Sidebar from "./components/dashboard/sidebar";
import Upload from "./components/dashboard/upload";
import ScannedStatus from "./components/dashboard/scannedStatus";
import History from "./components/dashboard/history";
import Settings from "./page/settings";
import Populate from "./components/dashboard/populate";
function App() {
  return (
    <div className="App">
      <ToastContainer />
      <Sidebar />
      <div className="page-wrapper">
        <Routes>
          <Route path="/" element={<Upload />} />
          <Route path="/scan-floor" element={<NewProject />} />
          <Route path="/scanned-status" element={<ScannedStatus />} />
          <Route path="/history" element={<History />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/populate" element={<Populate />} />
        </Routes>
      </div>
    </div>
  );
}
export default App;
